import React, { ComponentProps } from 'react';
import { Button, Spinner } from 'react-bootstrap';
import { useTranslation } from 'react-i18next';
import { FaArrowAltCircleLeft, FaSave } from 'react-icons/fa';

type Props = React.PropsWithoutRef<ComponentProps<typeof Button>> & {
  readonly loading?: boolean;
};

const ButtonCloseModal = ({ onClick, ...props }: Props) => {
  const { t, i18n } = useTranslation();
  return (
    <Button {...props} variant="dark" style={{ width: '160px' }} onClick={onClick}>
      <FaArrowAltCircleLeft className="mb-1" />
      &nbsp;
      {t('Κλείσιμο')}
    </Button>
  );
};

export default React.memo(ButtonCloseModal);

